const VehicleTypeEnum = {
  Vehicle: 1,
  Case: 2
};

export default VehicleTypeEnum;
